<template>
  <emd-modal
    :open="true"
    has-header
    has-footer
    @close="() => $emit('onCancel')"
  >
    <template v-slot:header>
      <h2 class="emd-text _size_section">
        {{ title }}
      </h2>
    </template>
    <template v-slot:content>
      <div class="_content-modal-success">
        <p class="eu-mt_3 eu-mb_3 _paragraph_color_success">
          {{ info }}
        </p>
        <p class="emd-text _align_center">
          {{ content }}
        </p>
      </div>
    </template>
    <template v-slot:footer>
      <div class="_content-modal-success">
        <emd-button
          data-testid="button-success-reset-secret-key"
          color="success"
          @click="$emit('onSubmit')"
          :text="$t('submitButton')"
        />
      </div>
    </template>
  </emd-modal>
</template>

<style scoped>
._content-modal-success {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
._paragraph_color_success {
  color: var(--brand--le--primary-color--base);
  font-size: 16px;
  font-weight: 600;
}
</style>

<i18n>
  {
    "pt-BR": {
      "submitButton": "Ok, entendi"
    },
    "en-US": {
      "submitButton": "Ok"
    }
  }
</i18n>

<script>
import { EmdModal, EmdButton } from 'emerald-vue/src/components'

export default {
  name: 'ModalInfo',
  components: {
    EmdModal,
    EmdButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    info: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    submitText: {
      type: String,
      default: 'Submit'
    }
  }
}
</script>
